import React, { useState, useEffect, useMemo, useRef } from 'react'
import {
  Users,
  Shuffle,
  Check,
  ChevronDown,
  Search,
  Plus,
  Trash2,
  UserPlus,
  RefreshCw,
  CheckCircle2,
  GraduationCap,
  AlertCircle,
  Ship,
  ArrowLeft
} from 'lucide-react'
import api from '../../../../services/authService'
import toast from 'react-hot-toast'
import { ExpedienteDespacho, GrupoInstitucion, MiembroInstitucion } from '../PaginaDespachoPortuario'

// ============================================================================
// CATÁLOGO DE 10 PLANTILLAS DE CASOS PORTUARIOS REALES (MANZANILLO TEC I)
// ============================================================================
export interface PlantillaCaso {
  id: string
  titulo: string
  mercancia: string
  tipoOperacion: 'EXPORTACION' | 'IMPORTACION'
  regimen: 'A1_DEFINITIVO' | 'IR_RFE' | 'IN_IMMEX'
  lineaNaviera: string
  tipoContenedor: '20DC' | '40HC' | '40RF' | 'ISOTANQUE'
  buqueNombre: string
  viaje: string
  puertoOrigen: string
  puertoDestino: string
  terminal: string
  incoterm: string
  valorUSD: number
  bultos: number
  pesoBrutoKg: number
  taraKg: number
  emisorNombre: string
  emisorRFC: string
  emisorPais: string
  receptorNombre: string
  receptorRFC: string
  receptorPais: string
  receptorDomicilio: string
  agenteNombre: string
  patente: string
  retoDiscrepancia: {
    codigo: string
    descripcion: string
    solucion: string
  }
}

export const CATALOGO_CASOS_PORTUARIOS: PlantillaCaso[] = [
  {
    id: 'CASO-01-CERVEZA',
    titulo: 'Exportación Cerveza Artesanal a Los Ángeles',
    mercancia: 'Cerveza artesanal embotellada en cajas sobre tarimas',
    tipoOperacion: 'EXPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'MSC',
    tipoContenedor: '40HC',
    buqueNombre: 'MSC GÜLSÜN',
    viaje: '2605E',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Los Ángeles, USA (USLAX)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'FOB Manzanillo',
    valorUSD: 44500,
    bultos: 1400,
    pesoBrutoKg: 21000,
    taraKg: 3900,
    emisorNombre: 'Cervecería de la Sierra S.A. de C.V.',
    emisorRFC: 'CSR180422AA9',
    emisorPais: 'México',
    receptorNombre: 'California Craft Distributors LLC',
    receptorRFC: 'CCD99214081',
    receptorPais: 'Estados Unidos',
    receptorDomicilio: 'East Olympic Blvd 120, Los Angeles, CA 90021',
    agenteNombre: 'Agencia Aduanal del Pacífico S.C.',
    patente: '3944',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_TAX_ID',
      descripcion: 'El RFC del receptor en la Factura difiere por un dígito del Tax ID reportado en el Bill of Lading.',
      solucion: 'El alumno receptor debe auditar el cotejo, no firmar tarja conforme y requerir rectificación de pedimento.'
    }
  },
  {
    id: 'CASO-02-AGUACATE',
    titulo: 'Exportación Aguacate Hass a Róterdam (Contenedor Refrigerado)',
    mercancia: 'Aguacate Hass calidad exportación en empaques ventilados',
    tipoOperacion: 'EXPORTACION',
    regimen: 'IR_RFE',
    lineaNaviera: 'MAERSK',
    tipoContenedor: '40RF',
    buqueNombre: 'MAERSK MC-KINNEY MOLLER',
    viaje: '2610W',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Róterdam, Países Bajos (NLRTM)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'CIF Rotterdam',
    valorUSD: 68000,
    bultos: 1920,
    pesoBrutoKg: 24800,
    taraKg: 4600,
    emisorNombre: 'AgroExportadores de Michoacán S.P.R. de R.L.',
    emisorRFC: 'AEM150422K89',
    emisorPais: 'México',
    receptorNombre: 'Rotterdam Fresh Logistics B.V.',
    receptorRFC: 'NL884912048B01',
    receptorPais: 'Países Bajos',
    receptorDomicilio: 'Waalhaven Oostzijde 14, 3087 BM Rotterdam',
    agenteNombre: 'Aduanas Internacionales Manzanillo S.C.',
    patente: '3450',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_PESO_VGM',
      descripcion: 'Báscula de patio detecta 25,650 kg (+850 kg sobre el VGM declarado en certificado).',
      solucion: 'El consignatario debe emitir acta de discrepancia por sobrepeso no amparado en el certificado VGM.'
    }
  },
  {
    id: 'CASO-03-TEQUILA',
    titulo: 'Exportación Tequila Reposado 100% Agave a Hamburgo',
    mercancia: 'Tequila Reposado con marbetes fiscales SAT en cajas de 12 botellas',
    tipoOperacion: 'EXPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'HAPAG-LLOYD',
    tipoContenedor: '20DC',
    buqueNombre: 'VALPARAISO EXPRESS',
    viaje: '098N',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Hamburgo, Alemania (DEHAM)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'FOB Manzanillo',
    valorUSD: 52000,
    bultos: 980,
    pesoBrutoKg: 14200,
    taraKg: 2200,
    emisorNombre: 'Destilería Los Altos de Jalisco S.A. de C.V.',
    emisorRFC: 'DAJ140510XX3',
    emisorPais: 'México',
    receptorNombre: 'Hanseatic Spirits Import GmbH',
    receptorRFC: 'DE814529103',
    receptorPais: 'Alemania',
    receptorDomicilio: 'Am Sandtorkai 48, 20457 Hamburg',
    agenteNombre: 'Manzanillo Customs Brokers S.C.',
    patente: '3120',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_MARBETE',
      descripcion: 'Inconsistencia en serie de marbetes reportada en Anexo 29 frente a la lista de empaque física.',
      solucion: 'El Agente Aduanal debe presentar escrito de justificación ante aduana y rectificar campo 16 del pedimento.'
    }
  },
  {
    id: 'CASO-04-ELECTRONICOS',
    titulo: 'Importación Definitiva Componentes de Telecomunicaciones desde Shanghái',
    mercancia: 'Circuitos integrados, microcontroladores y módems 5G',
    tipoOperacion: 'IMPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'COSCO',
    tipoContenedor: '40HC',
    buqueNombre: 'COSCO TAURUS',
    viaje: '098E',
    puertoOrigen: 'Shanghái, China (CNSHA)',
    puertoDestino: 'Manzanillo, México (MXZLO)',
    terminal: 'SSA México Manzanillo (Patio Externo)',
    incoterm: 'CFR Manzanillo',
    valorUSD: 115000,
    bultos: 850,
    pesoBrutoKg: 18400,
    taraKg: 3900,
    emisorNombre: 'Shenzhen Micro Devices Corp.',
    emisorRFC: 'CN99214488',
    emisorPais: 'China',
    receptorNombre: 'TecnoRed Logística de México S.A. de C.V.',
    receptorRFC: 'TLM190822K99',
    receptorPais: 'México',
    receptorDomicilio: 'Av. Industrial 450, Parque Tecnológico, Guadalajara, Jal.',
    agenteNombre: 'Despachos Internacionales del Puerto S.C.',
    patente: '3890',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_SELLO_FISCAL',
      descripcion: 'El número de sello de muelle no coincide con el sello anotado en el Bill of Lading emitido en origen.',
      solucion: 'El Receptor debe levantar acta circunstanciada de hechos y solicitar apertura con presencia aduanera.'
    }
  },
  {
    id: 'CASO-05-AUTOPARTES',
    titulo: 'Exportación Transmisiones Automotrices a Yokohama',
    mercancia: 'Conjuntos de transmisión y engranes automotrices industriales',
    tipoOperacion: 'EXPORTACION',
    regimen: 'IN_IMMEX',
    lineaNaviera: 'ONE',
    tipoContenedor: '40HC',
    buqueNombre: 'ONE APUS',
    viaje: '2104W',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Yokohama, Japón (JPYOK)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'FOB Manzanillo',
    valorUSD: 89000,
    bultos: 420,
    pesoBrutoKg: 22400,
    taraKg: 3900,
    emisorNombre: 'Motores y Transmisiones del Bajío S.A. de C.V.',
    emisorRFC: 'MTB120304Q91',
    emisorPais: 'México',
    receptorNombre: 'Nippon Automotive Supply Corp.',
    receptorRFC: 'JP774910283',
    receptorPais: 'Japón',
    receptorDomicilio: '1-1 Daikoku Pier, Tsurumi Ward, Yokohama, Kanagawa',
    agenteNombre: 'Agencia Aduanal de Occidente S.C.',
    patente: '3310',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_IMMEX',
      descripcion: 'El número de programa IMMEX declarado en pedimento no se encuentra vigente en el padrón VUCEM.',
      solucion: 'El Agente Aduanal debe requerir constancia de renovación de autorización de la Secretaría de Economía.'
    }
  },
  {
    id: 'CASO-06-MIEL',
    titulo: 'Exportación Miel Orgánica de Abeja a Amberes',
    mercancia: 'Miel de abeja virgen envasada en tambores de acero grado alimenticio',
    tipoOperacion: 'EXPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'CMA CGM',
    tipoContenedor: '20DC',
    buqueNombre: 'CMA CGM ANTOINE',
    viaje: '048E',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Amberes, Bélgica (BEANR)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'CIF Amberes',
    valorUSD: 41200,
    bultos: 75,
    pesoBrutoKg: 19800,
    taraKg: 2300,
    emisorNombre: 'Consorcio Apícola del Sureste S.C. de R.L.',
    emisorRFC: 'CAS160212M10',
    emisorPais: 'México',
    receptorNombre: 'Antwerp Bio-Sweeteners NV',
    receptorRFC: 'BE0458129034',
    receptorPais: 'Bélgica',
    receptorDomicilio: 'Haven 1025, 2030 Antwerpen, Bélgica',
    agenteNombre: 'Servicios Aduanales del Pacífico S.C.',
    patente: '3670',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_BP1_TERMINAL',
      descripcion: 'No se cuenta con comprobante de facturación de maniobra BP1 en portal SSA Marine antes del cut-off.',
      solucion: 'El Agente debe ingresar al módulo de facturación Forecast y liquidar el servicio BP1 para autorizar salida.'
    }
  },
  {
    id: 'CASO-07-BERRIES',
    titulo: 'Exportación Frutos Rojos y Zarzamora a Long Beach',
    mercancia: 'Zarzamora fresca en clamshells refrigerados con atmósfera controlada',
    tipoOperacion: 'EXPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'ZIM',
    tipoContenedor: '40RF',
    buqueNombre: 'ZIM SAMMY',
    viaje: '1102N',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Long Beach, USA (USLGB)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'CIF Long Beach',
    valorUSD: 72000,
    bultos: 2400,
    pesoBrutoKg: 23100,
    taraKg: 4600,
    emisorNombre: 'Frutas Finas de Zamora S.A. de C.V.',
    emisorRFC: 'FFZ170918L21',
    emisorPais: 'México',
    receptorNombre: 'Pacific Berries & Organics Inc.',
    receptorRFC: 'PBO88192031',
    receptorPais: 'Estados Unidos',
    receptorDomicilio: 'Pier G, Berth G235, Long Beach, CA 90802',
    agenteNombre: 'Corporativo Aduanero Manzanillo S.C.',
    patente: '3780',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_TEMPERATURA',
      descripcion: 'El termógrafo del contenedor reporta +6.5°C cuando la instrucción de embarque fijó +1.5°C continuo.',
      solucion: 'El Receptor debe ordenar inspección de peritaje fitosanitario previo a firmar la tarja SSA.'
    }
  },
  {
    id: 'CASO-08-MAQUINARIA',
    titulo: 'Importación Maquinaria Pesada en Flat Rack desde Busan',
    mercancia: 'Excavadora sobre orugas sobredimensionada con pluma desmontada',
    tipoOperacion: 'IMPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'HYUNDAI',
    tipoContenedor: '40HC',
    buqueNombre: 'HYUNDAI PRIDE',
    viaje: '007W',
    puertoOrigen: 'Busan, Corea del Sur (KRPUS)',
    puertoDestino: 'Manzanillo, México (MXZLO)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'FOB Busan',
    valorUSD: 145000,
    bultos: 1,
    pesoBrutoKg: 28500,
    taraKg: 5200,
    emisorNombre: 'Doosan Heavy Equipment Co. Ltd.',
    emisorRFC: 'KR99182310',
    emisorPais: 'Corea del Sur',
    receptorNombre: 'Minera y Construcciones del Norte S.A. de C.V.',
    receptorRFC: 'MCN110620T88',
    receptorPais: 'México',
    receptorDomicilio: 'Carretera Internacional Km 8.5, Hermosillo, Sonora',
    agenteNombre: 'Agencia Aduanal Especializada del Puerto S.C.',
    patente: '3215',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_SERIE_MOTOR',
      descripcion: 'El número de serie troquelado en chasis no coincide con el pedimento en los últimos 2 caracteres.',
      solucion: 'El Agente debe formular acta de rectificación antes de modulación aduanera para evitar PAMA.'
    }
  },
  {
    id: 'CASO-09-CAFE',
    titulo: 'Exportación Café Gourmet Arábica a Marsella',
    mercancia: 'Café en grano verde calidad estricta altura en sacos de henequén',
    tipoOperacion: 'EXPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'MSC',
    tipoContenedor: '20DC',
    buqueNombre: 'MSC LA SPEZIA',
    viaje: '3312E',
    puertoOrigen: 'Manzanillo, México (MXZLO)',
    puertoDestino: 'Marsella, Francia (FRMRS)',
    terminal: 'SSA México Manzanillo (TEC I)',
    incoterm: 'CIF Marsella',
    valorUSD: 48900,
    bultos: 320,
    pesoBrutoKg: 19200,
    taraKg: 2200,
    emisorNombre: 'Beneficio Cafetalero Coatepec S.P.R.',
    emisorRFC: 'BCC130825P44',
    emisorPais: 'México',
    receptorNombre: 'Marseille Café & Torréfaction SAS',
    receptorRFC: 'FR5591028341',
    receptorPais: 'Francia',
    receptorDomicilio: 'Quai de la Joliette 24, 13002 Marseille',
    agenteNombre: 'Aduanas Marítimas de Manzanillo S.C.',
    patente: '3560',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_FECHA_CITA',
      descripcion: 'La cita PIS asignada tiene fecha posterior al cut-off físico del buque en terminal SSA.',
      solucion: 'El Emisor debe solicitar reprogramación urgente de cita PIS y revalidación de booking.'
    }
  },
  {
    id: 'CASO-10-RESINAS',
    titulo: 'Importación Resina Plástica Granulada desde Kaohsiung',
    mercancia: 'Pellets de polipropileno virgen en big bags de 1,000 kg',
    tipoOperacion: 'IMPORTACION',
    regimen: 'A1_DEFINITIVO',
    lineaNaviera: 'EVERGREEN',
    tipoContenedor: '40HC',
    buqueNombre: 'EVER GIVEN',
    viaje: '0291W',
    puertoOrigen: 'Kaohsiung, Taiwán (TWKHH)',
    puertoDestino: 'Manzanillo, México (MXZLO)',
    terminal: 'SSA México Manzanillo (Patio Externo)',
    incoterm: 'CFR Manzanillo',
    valorUSD: 36800,
    bultos: 22,
    pesoBrutoKg: 22000,
    taraKg: 3900,
    emisorNombre: 'Formosa Plastics Corp.',
    emisorRFC: 'TW77182903',
    emisorPais: 'Taiwán',
    receptorNombre: 'Termoplásticos del Centro S.A. de C.V.',
    receptorRFC: 'TCE140411AB2',
    receptorPais: 'México',
    receptorDomicilio: 'Parque Industrial Toluca 2000, Edo. de México',
    agenteNombre: 'Agencia Aduanal de Manzanillo S.C.',
    patente: '3944',
    retoDiscrepancia: {
      codigo: 'DISCREPANCIA_TARA_CONTENEDOR',
      descripcion: 'Diferencia de 450 kg en tara declarada en Anexo 29 frente a la placa CSC del contenedor.',
      solucion: 'El Agente debe actualizar la tara real verificando la fotografía de la placa CSC tomada en previo.'
    }
  }
]

// ============================================================================
// ESTRUCTURA DE UNA CÉLULA / TERNA DE PRÁCTICA
// ============================================================================
export interface ActorAlumno {
  idUsuario?: number
  nombre: string
  email?: string
}

export interface CelulaPractica {
  idCelula: string
  numero: number
  plantillaId: string
  tituloPersonalizado?: string
  inyectarReto: boolean
  // Roles de la terna
  emisor: ActorAlumno
  agenteAduanal: ActorAlumno
  receptor: ActorAlumno
}

// Props del Componente Principal
interface Props {
  grupos: GrupoInstitucion[]
  miembros: MiembroInstitucion[]
  onPublicarCasos: (nuevosCasos: ExpedienteDespacho[]) => Promise<void>
  onVolver: () => void
  grupoPreseleccionadoId?: number
}

// ============================================================================
// COMPONENTE: SELECTOR ELEGANTE DE ALUMNO (SIN NATIVE SELECT BLANCO NI INPUT DUPLICADO)
// ============================================================================
interface SelectorAlumnoProps {
  rol: 'EMISOR' | 'AGENTE' | 'RECEPTOR' | 'INDIVIDUAL'
  labelRol: string
  alumnoSeleccionado: { idUsuario?: number; nombre: string; email?: string }
  onChange: (alumno: { idUsuario?: number; nombre: string; email?: string }) => void
  alumnosDisponibles: any[]
}

const SelectorAlumno: React.FC<SelectorAlumnoProps> = ({
  rol,
  labelRol,
  alumnoSeleccionado,
  onChange,
  alumnosDisponibles
}) => {
  const [abierto, setAbierto] = useState(false)
  const [busqueda, setBusqueda] = useState('')
  const contenedorRef = useRef<HTMLDivElement>(null)

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (contenedorRef.current && !contenedorRef.current.contains(e.target as Node)) {
        setAbierto(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Estilos según rol
  const colores = {
    EMISOR: {
      border: 'border-blue-500/30',
      bgBadge: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
      avatarBg: 'from-blue-600 to-cyan-600',
      textoRol: 'text-blue-600 dark:text-blue-400'
    },
    AGENTE: {
      border: 'border-amber-500/30',
      bgBadge: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
      avatarBg: 'from-amber-600 to-orange-600',
      textoRol: 'text-amber-600 dark:text-amber-400'
    },
    RECEPTOR: {
      border: 'border-purple-500/30',
      bgBadge: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
      avatarBg: 'from-purple-600 to-pink-600',
      textoRol: 'text-purple-600 dark:text-purple-400'
    },
    INDIVIDUAL: {
      border: 'border-cyan-500/30',
      bgBadge: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border-cyan-500/20',
      avatarBg: 'from-cyan-600 to-blue-600',
      textoRol: 'text-cyan-600 dark:text-cyan-400'
    }
  }[rol]

  const alumnosFiltrados = useMemo(() => {
    const q = busqueda.toLowerCase().trim()
    if (!q) return alumnosDisponibles
    return alumnosDisponibles.filter((a) => {
      const nombreCompleto = `${a.nombre || ''} ${a.apellido || ''}`.toLowerCase()
      const correo = (a.email || '').toLowerCase()
      return nombreCompleto.includes(q) || correo.includes(q)
    })
  }, [alumnosDisponibles, busqueda])

  const obtenerIniciales = (nombre: string) => {
    const partes = nombre.trim().split(' ')
    if (partes.length >= 2) return `${partes[0][0]}${partes[1][0]}`.toUpperCase()
    return (nombre.slice(0, 2) || 'AL').toUpperCase()
  }

  const tieneSeleccion = Boolean(alumnoSeleccionado.nombre)

  return (
    <div className="space-y-1.5" ref={contenedorRef}>
      <label className={`text-[11px] font-bold uppercase tracking-wider block ${colores.textoRol}`}>
        {labelRol}
      </label>

      <div className="relative">
        {/* Botón Disparador del Selector */}
        <button
            type="button"
            onClick={() => setAbierto(!abierto)}
            className={`w-full flex items-center justify-between p-2.5 rounded-xl border text-left text-xs transition-all ${
              tieneSeleccion
                ? `bg-slate-50 dark:bg-[#121218] ${colores.border} shadow-sm`
                : 'bg-slate-100/70 dark:bg-white/[0.03] border-dashed border-slate-300 dark:border-white/15 hover:border-slate-400 dark:hover:border-white/30 text-slate-500 dark:text-zinc-400'
            }`}
          >
            <div className="flex items-center gap-2.5 min-w-0 pr-2">
              {tieneSeleccion ? (
                <>
                  <div
                    className={`h-7 w-7 rounded-lg bg-gradient-to-br ${colores.avatarBg} text-white flex items-center justify-center font-bold text-[10px] shrink-0 shadow-sm`}
                  >
                    {obtenerIniciales(alumnoSeleccionado.nombre)}
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold text-slate-900 dark:text-white text-xs truncate">
                      {alumnoSeleccionado.nombre}
                    </p>
                    <p className="text-[10px] text-slate-500 dark:text-zinc-400 truncate">
                      {alumnoSeleccionado.email || 'Alumno inscrito'}
                    </p>
                  </div>
                </>
              ) : (
                <div className="flex items-center gap-2">
                  <UserPlus className="h-4 w-4 opacity-60" />
                  <span>+ Seleccionar Alumno...</span>
                </div>
              )}
            </div>

            <ChevronDown
              className={`h-4 w-4 text-slate-400 shrink-0 transition-transform ${abierto ? 'rotate-180' : ''}`}
            />
          </button>

          {/* Menú Desplegable con Tema Oscuro Impecable */}
          {abierto && (
            <div className="absolute z-50 left-0 right-0 mt-1.5 p-2 rounded-2xl bg-white dark:bg-[#111116] border border-slate-200 dark:border-white/15 shadow-2xl space-y-2 backdrop-blur-xl animate-in fade-in zoom-in-95 duration-100">
              {/* Buscador */}
              <div className="relative">
                <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400" />
                <input
                  type="text"
                  autoFocus
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  placeholder="Buscar por nombre o correo..."
                  className="w-full pl-8 pr-3 py-1.5 rounded-lg text-xs bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 dark:text-white focus:outline-none focus:border-indigo-500"
                />
              </div>

              {/* Lista de Alumnos */}
              <div className="max-h-48 overflow-y-auto space-y-1 pr-1 custom-scrollbar">
                {alumnosFiltrados.length === 0 ? (
                  <div className="py-4 text-center">
                    <p className="text-xs text-slate-400 dark:text-zinc-500">
                      No se encontraron alumnos con ese nombre.
                    </p>
                    {busqueda.trim() && (
                      <button
                        type="button"
                        onClick={() => {
                          onChange({ nombre: busqueda.trim() })
                          setAbierto(false)
                        }}
                        className="mt-2 text-xs font-bold text-indigo-500 hover:underline"
                      >
                        Usar "{busqueda.trim()}" como nombre manual
                      </button>
                    )}
                  </div>
                ) : (
                  alumnosFiltrados.map((item) => {
                    const nombreCompleto =
                      item.nombre && item.apellido
                        ? `${item.nombre} ${item.apellido}`
                        : item.nombre || 'Alumno'
                    const estaSeleccionado =
                      alumnoSeleccionado.idUsuario === item.id_usuario ||
                      alumnoSeleccionado.nombre === nombreCompleto

                    return (
                      <button
                        key={item.id_usuario || item.id_miembro || item.email || nombreCompleto}
                        type="button"
                        onClick={() => {
                          onChange({
                            idUsuario: item.id_usuario,
                            nombre: nombreCompleto,
                            email: item.email
                          })
                          setAbierto(false)
                        }}
                        className={`w-full flex items-center justify-between p-2 rounded-xl text-left transition-all ${
                          estaSeleccionado
                            ? 'bg-indigo-500/15 text-indigo-600 dark:text-indigo-400 font-bold'
                            : 'hover:bg-slate-100 dark:hover:bg-white/5 text-slate-700 dark:text-zinc-300'
                        }`}
                      >
                        <div className="flex items-center gap-2 min-w-0 pr-2">
                          <div
                            className={`h-6 w-6 rounded-md bg-gradient-to-br ${colores.avatarBg} text-white flex items-center justify-center font-bold text-[9px] shrink-0`}
                          >
                            {obtenerIniciales(nombreCompleto)}
                          </div>
                          <div className="min-w-0">
                            <p className="text-xs truncate font-medium">{nombreCompleto}</p>
                            <p className="text-[10px] text-slate-400 dark:text-zinc-500 truncate">
                              {item.email || item.rol_miembro || 'Alumno'}
                            </p>
                          </div>
                        </div>

                        {estaSeleccionado && <Check className="h-4 w-4 text-indigo-500 shrink-0" />}
                      </button>
                    )
                  })
                )}
              </div>
            </div>
          )}
        </div>
    </div>
  )
}

// ============================================================================
// ============================================================================
// COMPONENTE PRINCIPAL: CONFIGURADOR PEDAGÓGICO DE PRÁCTICAS
// ============================================================================
export const ConfiguradorPracticasAulas: React.FC<Props> = ({
  grupos,
  miembros,
  onPublicarCasos,
  onVolver,
  grupoPreseleccionadoId
}) => {
  // Modalidad: 'individual' (1 caso por alumno) vs 'equipos' (roles colaborativos)
  const [modo, setModo] = useState<'individual' | 'equipos'>('individual')

  // Estado del Grupo seleccionado (por defecto el salón real 4-CAS-1)
  const [idGrupoSeleccionado, setIdGrupoSeleccionado] = useState<number | undefined>(
    grupoPreseleccionadoId || grupos[0]?.id_grupo
  )
  const [miembrosDelGrupo, setMiembrosDelGrupo] = useState<any[]>([])
  const [cargandoMiembros, setCargandoMiembros] = useState(false)
  const [publicando, setPublicando] = useState(false)

  // Cargar miembros del grupo seleccionado desde FastAPI
  useEffect(() => {
    if (idGrupoSeleccionado) {
      setCargandoMiembros(true)
      api
        .get(`/api/institucion/grupos/${idGrupoSeleccionado}/miembros`)
        .then((res) => {
          setMiembrosDelGrupo(Array.isArray(res.data) ? res.data : [])
        })
        .catch((err) => {
          console.warn('Error cargando miembros del grupo institucional:', err)
          setMiembrosDelGrupo([])
        })
        .finally(() => setCargandoMiembros(false))
    } else {
      setMiembrosDelGrupo([])
    }
  }, [idGrupoSeleccionado])

  // Obtener la lista unificada de alumnos REALES para este grupo
  const listaAlumnosDisponibles = useMemo(() => {
    if (miembrosDelGrupo.length > 0) return miembrosDelGrupo
    if (miembros.length > 0) {
      const delGrupo = miembros.filter(
        (m) =>
          (m.id_grupo === idGrupoSeleccionado || !m.id_grupo) &&
          ['alumno', 'estudiante'].includes(m.rol_miembro?.toLowerCase() || '')
      )
      if (delGrupo.length > 0) return delGrupo
      return miembros.filter((m) =>
        ['alumno', 'estudiante'].includes(m.rol_miembro?.toLowerCase() || '')
      )
    }
    return []
  }, [miembrosDelGrupo, miembros, idGrupoSeleccionado])

  // Grupo activo
  const grupoActivo = useMemo(() => {
    return grupos.find((g) => g.id_grupo === idGrupoSeleccionado) || grupos[0]
  }, [grupos, idGrupoSeleccionado])

  // Estados de casos para cada modalidad
  const [casosIndividuales, setCasosIndividuales] = useState<
    {
      idCaso: string
      numero: number
      plantillaId: string
      tituloPersonalizado?: string
      alumno: ActorAlumno
      inyectarReto: boolean
    }[]
  >([])

  const [celulas, setCelulas] = useState<CelulaPractica[]>([])

  // Función para distribuir automáticamente basada en los alumnos REALES del salón
  const inicializarDistribucion = (alumnos: any[]) => {
    const getNombre = (a: any, fallback: string) => {
      if (!a) return fallback
      if (a.nombre && a.apellido) return `${a.nombre} ${a.apellido}`.trim()
      return a.nombre || fallback
    }

    // 1. Modo Individual: 1 caso para cada alumno del salón
    if (alumnos.length > 0) {
      const nuevosCasos = alumnos.map((alm, idx) => {
        const plantilla = CATALOGO_CASOS_PORTUARIOS[idx % CATALOGO_CASOS_PORTUARIOS.length]
        return {
          idCaso: `IND-${idx + 1}-${Date.now()}`,
          numero: idx + 1,
          plantillaId: plantilla.id,
          tituloPersonalizado: `${plantilla.titulo} · ${getNombre(alm, 'Alumno')}`,
          alumno: {
            idUsuario: alm.id_usuario,
            nombre: getNombre(alm, `Alumno ${idx + 1}`),
            email: alm.email
          },
          inyectarReto: idx % 2 === 1
        }
      })
      setCasosIndividuales(nuevosCasos)
    } else {
      const plantilla = CATALOGO_CASOS_PORTUARIOS[0]
      setCasosIndividuales([
        {
          idCaso: `IND-1-${Date.now()}`,
          numero: 1,
          plantillaId: plantilla.id,
          tituloPersonalizado: plantilla.titulo,
          alumno: { nombre: 'Alumno 1' },
          inyectarReto: false
        }
      ])
    }

    // 2. Modo Equipos: agrupar a los alumnos reales
    const cantidadEquipos = Math.max(1, Math.ceil((alumnos.length || 1) / 3))
    const nuevasCelulas: CelulaPractica[] = []

    for (let i = 0; i < cantidadEquipos; i++) {
      const a1 = alumnos[i * 3]
      const a2 = alumnos[i * 3 + 1] || alumnos[i * 3]
      const a3 = alumnos[i * 3 + 2] || alumnos[i * 3 + 1] || alumnos[i * 3]

      const plantilla = CATALOGO_CASOS_PORTUARIOS[i % CATALOGO_CASOS_PORTUARIOS.length]

      nuevasCelulas.push({
        idCelula: `EQ-${i + 1}-${Date.now()}`,
        numero: i + 1,
        plantillaId: plantilla.id,
        tituloPersonalizado: plantilla.titulo,
        inyectarReto: i % 2 === 1,
        emisor: {
          idUsuario: a1?.id_usuario,
          nombre: getNombre(a1, 'Alumno Exportador'),
          email: a1?.email
        },
        agenteAduanal: {
          idUsuario: a2?.id_usuario,
          nombre: getNombre(a2, 'Agente Aduanal'),
          email: a2?.email
        },
        receptor: {
          idUsuario: a3?.id_usuario,
          nombre: getNombre(a3, 'Alumno Receptor'),
          email: a3?.email
        }
      })
    }
    setCelulas(nuevasCelulas)
  }

  // Inicializar cuando cambie la lista de alumnos
  useEffect(() => {
    inicializarDistribucion(listaAlumnosDisponibles)
  }, [listaAlumnosDisponibles])

  // Modificar un caso individual
  const actualizarCasoIndividual = (
    idCaso: string,
    campos: Partial<(typeof casosIndividuales)[0]>
  ) => {
    setCasosIndividuales((prev) =>
      prev.map((c) => (c.idCaso === idCaso ? { ...c, ...campos } : c))
    )
  }

  // Eliminar caso individual
  const eliminarCasoIndividual = (idCaso: string) => {
    if (casosIndividuales.length <= 1) {
      toast.error('Debe existir al menos 1 caso en la práctica.')
      return
    }
    setCasosIndividuales((prev) => prev.filter((c) => c.idCaso !== idCaso))
  }

  // Agregar caso individual
  const agregarCasoIndividual = () => {
    const proximoNum = casosIndividuales.length + 1
    const plantilla = CATALOGO_CASOS_PORTUARIOS[(proximoNum - 1) % CATALOGO_CASOS_PORTUARIOS.length]
    setCasosIndividuales((prev) => [
      ...prev,
      {
        idCaso: `IND-${proximoNum}-${Date.now()}`,
        numero: proximoNum,
        plantillaId: plantilla.id,
        tituloPersonalizado: plantilla.titulo,
        alumno: { nombre: '' },
        inyectarReto: false
      }
    ])
  }

  // Modificar un equipo
  const actualizarCelula = (idCelula: string, campos: Partial<CelulaPractica>) => {
    setCelulas((prev) =>
      prev.map((c) => (c.idCelula === idCelula ? { ...c, ...campos } : c))
    )
  }

  // Eliminar equipo
  const eliminarCelula = (idCelula: string) => {
    if (celulas.length <= 1) {
      toast.error('Debe existir al menos 1 equipo en la práctica.')
      return
    }
    setCelulas((prev) => prev.filter((c) => c.idCelula !== idCelula))
  }

  // Agregar equipo
  const agregarCelulaManual = () => {
    const proximoNum = celulas.length + 1
    const plantilla = CATALOGO_CASOS_PORTUARIOS[(proximoNum - 1) % CATALOGO_CASOS_PORTUARIOS.length]
    setCelulas((prev) => [
      ...prev,
      {
        idCelula: `EQ-${proximoNum}-${Date.now()}`,
        numero: proximoNum,
        plantillaId: plantilla.id,
        tituloPersonalizado: plantilla.titulo,
        inyectarReto: false,
        emisor: { nombre: 'Alumno Exportador' },
        agenteAduanal: { nombre: 'Agente Aduanal' },
        receptor: { nombre: 'Alumno Receptor' }
      }
    ])
  }

  // Generador de objeto ExpedienteDespacho a partir de una terna o caso individual
  const construirExpediente = (
    plantilla: PlantillaCaso,
    emisor: ActorAlumno,
    agente: ActorAlumno,
    receptor: ActorAlumno,
    conReto: boolean,
    tituloCustom?: string
  ): ExpedienteDespacho => {
    const randomSuffix = Math.floor(1000 + Math.random() * 9000)
    const numeroContenedor = `${plantilla.lineaNaviera.slice(0, 3)}U${Math.floor(1000000 + Math.random() * 9000000)}`
    const folioPedimento = `26 16 3944 ${Math.floor(1000000 + Math.random() * 9000000)}`
    const blNumero = `${plantilla.lineaNaviera.slice(0, 4)}ZLO${randomSuffix}`

    return {
      id: `DSP-AULA-${randomSuffix}`,
      folio: `EXP-ZLO-${randomSuffix}`,
      titulo: tituloCustom || plantilla.titulo,
      tipoOperacion: plantilla.tipoOperacion,
      regimen: plantilla.regimen,
      estado: conReto ? 'INCIDENCIA' : 'ESPERANDO_MODULACION',
      contenedor: {
        numero: numeroContenedor,
        tipo: plantilla.tipoContenedor,
        lineaNaviera: plantilla.lineaNaviera,
        pesoBrutoKg: conReto ? plantilla.pesoBrutoKg + 850 : plantilla.pesoBrutoKg,
        taraKg: plantilla.taraKg,
        vgmDeclaradoKg: plantilla.pesoBrutoKg,
        sellos: `MX-SAT-${randomSuffix} // ${plantilla.lineaNaviera}-99`,
        servicioBP1Facturado: !conReto
      },
      buque: {
        nombre: plantilla.buqueNombre,
        viaje: plantilla.viaje,
        puertoOrigen: plantilla.puertoOrigen,
        puertoDestino: plantilla.puertoDestino,
        terminal: plantilla.terminal,
        cutOffDocs: '12/10/2026 18:00'
      },
      actores: {
        emisor: {
          nombre: plantilla.emisorNombre,
          rfc: plantilla.emisorRFC,
          pais: plantilla.emisorPais,
          alumnoId: emisor.idUsuario,
          alumnoNombre: `${emisor.nombre} (Exportador / Shipper)`
        },
        receptor: {
          nombre: conReto ? `${plantilla.receptorNombre} (Discrepancia Fiscal)` : plantilla.receptorNombre,
          rfc: conReto ? `${plantilla.receptorRFC}-ERR` : plantilla.receptorRFC,
          pais: plantilla.receptorPais,
          domicilio: plantilla.receptorDomicilio,
          alumnoId: receptor.idUsuario,
          alumnoNombre: `${receptor.nombre} (Consignatario / Receptor)`
        },
        agenteAduanal: {
          nombre: `Agencia Aduanal de ${agente.nombre}`,
          patente: plantilla.patente,
          aduana: 'Manzanillo (160)',
          alumnoId: agente.idUsuario,
          alumnoNombre: `${agente.nombre} (Agente Aduanal)`
        },
        transportista: {
          razonSocial: 'Autotransportes de Carga del Pacífico S.A. de C.V.',
          caat: '8U22',
          chofer: 'Juan Morales Mendoza',
          placas: '33-KL-99'
        }
      },
      documentos: {
        factura: {
          folio: `FAC-2026-${randomSuffix}`,
          valorUSD: plantilla.valorUSD,
          incoterm: plantilla.incoterm,
          fecha: new Date().toLocaleDateString('es-MX')
        },
        packingList: {
          bultos: plantilla.bultos,
          pesoNetoKg: plantilla.pesoBrutoKg - plantilla.taraKg
        },
        bl: {
          numero: blNumero,
          consignee: conReto ? `${plantilla.receptorNombre} (Discrepancia Fiscal)` : plantilla.receptorNombre,
          shipper: plantilla.emisorNombre
        },
        anexo29: {
          folio: folioPedimento,
          fechaCaptura: new Date().toLocaleString('es-MX'),
          capturado: true
        },
        pasePIS: {
          codigoCita: `PIS-${Math.floor(1000000 + Math.random() * 9000000)}`,
          fechaCita: 'Mañana 10:00 AM',
          iconoBascula: true
        }
      },
      incidencia: conReto
        ? {
            activa: true,
            codigo: plantilla.retoDiscrepancia.codigo,
            descripcion: `RETO AUDITORÍA: ${plantilla.retoDiscrepancia.descripcion}`,
            solucion: plantilla.retoDiscrepancia.solucion
          }
        : null,
      tarjaInternacion: {
        firmadaPorReceptor: false,
        resultado: 'PENDIENTE'
      },
      idGrupo: idGrupoSeleccionado,
      grupoNombre: grupoActivo?.nombre || 'Grupo Institucional',
      fechaCreacion: new Date().toLocaleDateString('es-MX')
    }
  }

  // Publicar casos en backend y frontend
  const handlePublicar = async () => {
    setPublicando(true)
    const toastId = toast.loading('Sincronizando prácticas del salón con el servidor...')

    try {
      const expedientesNuevos: ExpedienteDespacho[] = []

      if (modo === 'individual') {
        for (const item of casosIndividuales) {
          const plantilla =
            CATALOGO_CASOS_PORTUARIOS.find((p) => p.id === item.plantillaId) ||
            CATALOGO_CASOS_PORTUARIOS[0]

          const exp = construirExpediente(
            plantilla,
            item.alumno,
            item.alumno,
            item.alumno,
            item.inyectarReto,
            item.tituloPersonalizado
          )
          expedientesNuevos.push(exp)
        }
      } else {
        for (const cel of celulas) {
          const plantilla =
            CATALOGO_CASOS_PORTUARIOS.find((p) => p.id === cel.plantillaId) ||
            CATALOGO_CASOS_PORTUARIOS[0]

          const exp = construirExpediente(
            plantilla,
            cel.emisor,
            cel.agenteAduanal,
            cel.receptor,
            cel.inyectarReto,
            cel.tituloPersonalizado
          )
          expedientesNuevos.push(exp)
        }
      }

      // Persistir simulaciones en el backend FastAPI
      for (const caso of expedientesNuevos) {
        try {
          const res = await api.post('/api/simulaciones', {
            titulo: caso.titulo,
            descripcion: `Despacho Portuario - ${caso.folio} (${caso.contenedor.lineaNaviera})`,
            tipo: 'DespachoPortuario',
            nivel_dificultad: caso.incidencia ? 'avanzado' : 'intermedio',
            datos_caso: caso
          })
          if (res.data?.id) {
            caso.idSimulacion = res.data.id
            if (idGrupoSeleccionado) {
              try {
                await api.post('/api/simulaciones/asignar', {
                  id_grupo: idGrupoSeleccionado,
                  id_simulacion: res.data.id
                })
              } catch (e) {}
            }
          }
        } catch (e) {
          console.warn('Simulación guardada en caché local:', e)
        }
      }

      await onPublicarCasos(expedientesNuevos)
      toast.success(
        `¡${expedientesNuevos.length} práctica(s) creadas y asignadas con éxito al Salón ${grupoActivo?.nombre || ''}!`,
        { id: toastId }
      )
      onVolver()
    } catch (error) {
      console.error('Error publicando casos:', error)
      toast.error('Ocurrió un error al sincronizar con el servidor.', { id: toastId })
    } finally {
      setPublicando(false)
    }
  }

  const cantidadCasos = modo === 'individual' ? casosIndividuales.length : celulas.length

  return (
    <div className="max-w-5xl mx-auto space-y-6 animate-in fade-in duration-300 pb-12">
      {/* ========================================================================= */}
      {/* HEADER BENTO: ALINEADO A ALMACÉN DE PRÁCTICA */}
      {/* ========================================================================= */}
      <div className="p-6 md:p-8 rounded-[24px] bg-white/80 dark:bg-[#0c0c0c] backdrop-blur-xl border border-slate-200/80 dark:border-white/[0.08] shadow-xl">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 flex items-center justify-center text-cyan-500 dark:text-cyan-400 shrink-0 shadow-lg shadow-cyan-500/10">
              <Ship className="w-6 h-6" />
            </div>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="px-3 py-0.5 rounded-full text-[10px] font-bold bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 border border-cyan-500/20">
                  SSA Manzanillo TEC I
                </span>
                <span className="px-3 py-0.5 rounded-full text-[10px] font-bold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20">
                  Prácticas de Aula
                </span>
              </div>
              <h2 className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white tracking-tight">
                Configurador de Prácticas de Aula
              </h2>
              <p className="text-xs text-slate-600 dark:text-zinc-400 max-w-2xl leading-relaxed">
                Asigna operaciones portuarias y aduaneras a los alumnos de tu salón con casos reales.
                Selecciona entre evaluación <strong>Individual</strong> o <strong>Equipos Colaborativos</strong>.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onVolver}
            className="self-start md:self-center px-4 py-2 rounded-xl border border-slate-200 dark:border-white/10 text-xs font-bold text-slate-700 dark:text-zinc-300 hover:bg-slate-100 dark:hover:bg-white/5 transition-all flex items-center gap-1.5"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Volver a Expedientes</span>
          </button>
        </div>
      </div>

      {/* ========================================================================= */}
      {/* TARJETA BENTO: SALÓN Y MODALIDAD */}
      {/* ========================================================================= */}
      <div className="p-6 rounded-[24px] bg-white/80 dark:bg-[#0c0c0c] backdrop-blur-xl border border-slate-200/80 dark:border-white/[0.08] shadow-xl space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
          {/* Selector de Salón */}
          <div className="md:col-span-2 space-y-1.5">
            <label className="block text-xs font-bold text-slate-700 dark:text-zinc-300">
              Salón Institucional *
            </label>
            <select
              value={idGrupoSeleccionado || ''}
              onChange={(e) => setIdGrupoSeleccionado(Number(e.target.value) || undefined)}
              className="w-full px-4 py-2.5 rounded-xl text-xs bg-slate-100/80 dark:bg-[#121217] border border-slate-200 dark:border-white/10 dark:text-white font-bold focus:outline-none focus:border-cyan-500 [&>option]:bg-white dark:[&>option]:bg-[#121217]"
            >
              {grupos.map((g) => (
                <option key={g.id_grupo} value={g.id_grupo}>
                  {g.nombre} {g.descripcion ? `· ${g.descripcion}` : ''} ({g.miembros_count || 0} alumnos)
                </option>
              ))}
            </select>
          </div>

          {/* Estadísticas Reales del Salón */}
          <div className="p-3.5 rounded-xl bg-slate-50 dark:bg-white/[0.02] border border-slate-200/60 dark:border-white/5 flex items-center justify-between">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-zinc-500">
                Alumnos en Salón
              </p>
              <p className="text-lg font-black text-slate-900 dark:text-white">
                {cargandoMiembros ? (
                  <span className="text-xs text-cyan-400 animate-pulse">Cargando...</span>
                ) : (
                  `${listaAlumnosDisponibles.length} Alumnos`
                )}
              </p>
            </div>
            <div className="text-right">
              <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-zinc-500">
                Modalidad
              </p>
              <p className="text-sm font-bold text-cyan-600 dark:text-cyan-400">
                {modo === 'individual' ? '1 por Alumno' : 'Equipos'}
              </p>
            </div>
          </div>
        </div>

        {/* Selector de Modalidad Segmentado en Píldoras */}
        <div className="pt-4 border-t border-slate-100 dark:border-white/5 space-y-3">
          <p className="text-xs font-bold text-slate-700 dark:text-zinc-300">
            Selecciona la Modalidad de Práctica:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {/* Botón Modo Individual */}
            <button
              type="button"
              onClick={() => setModo('individual')}
              className={`p-4 rounded-2xl border text-left transition-all flex items-start gap-3.5 ${
                modo === 'individual'
                  ? 'bg-cyan-500/10 border-cyan-500/40 text-slate-900 dark:text-white shadow-md shadow-cyan-500/5'
                  : 'bg-slate-50/50 dark:bg-white/[0.02] border-slate-200 dark:border-white/5 text-slate-600 dark:text-zinc-400 hover:border-slate-300 dark:hover:border-white/20'
              }`}
            >
              <div
                className={`p-2.5 rounded-xl shrink-0 ${
                  modo === 'individual'
                    ? 'bg-cyan-500 text-white'
                    : 'bg-slate-200 dark:bg-white/10 text-slate-500 dark:text-zinc-400'
                }`}
              >
                <GraduationCap className="h-5 w-5" />
              </div>
              <div className="space-y-0.5">
                <div className="flex items-center gap-2">
                  <p className="text-xs font-black">Práctica Individual (1 Caso por Alumno)</p>
                  <span className="text-[9px] font-bold uppercase px-2 py-0.5 rounded-full bg-cyan-500/20 text-cyan-600 dark:text-cyan-400">
                    Recomendado
                  </span>
                </div>
                <p className="text-[11px] text-slate-500 dark:text-zinc-400 leading-snug">
                  Cada alumno del salón resuelve su propia operación portuaria completa (Emisor, Aduana y Receptor).
                </p>
              </div>
            </button>

            {/* Botón Modo Equipos */}
            <button
              type="button"
              onClick={() => setModo('equipos')}
              className={`p-4 rounded-2xl border text-left transition-all flex items-start gap-3.5 ${
                modo === 'equipos'
                  ? 'bg-indigo-500/10 border-indigo-500/40 text-slate-900 dark:text-white shadow-md shadow-indigo-500/5'
                  : 'bg-slate-50/50 dark:bg-white/[0.02] border-slate-200 dark:border-white/5 text-slate-600 dark:text-zinc-400 hover:border-slate-300 dark:hover:border-white/20'
              }`}
            >
              <div
                className={`p-2.5 rounded-xl shrink-0 ${
                  modo === 'equipos'
                    ? 'bg-indigo-600 text-white'
                    : 'bg-slate-200 dark:bg-white/10 text-slate-500 dark:text-zinc-400'
                }`}
              >
                <Users className="h-5 w-5" />
              </div>
              <div className="space-y-0.5">
                <p className="text-xs font-black">Trabajo en Equipos (Roles Colaborativos)</p>
                <p className="text-[11px] text-slate-500 dark:text-zinc-400 leading-snug">
                  Los alumnos se dividen en equipos y se reparten los 3 roles de comercio exterior (Exportador, Agente Aduanal y Receptor).
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* ========================================================================= */}
      {/* VISTA 1: MODO INDIVIDUAL (1 CASO POR ALUMNO REAL) */}
      {/* ========================================================================= */}
      {modo === 'individual' && (
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3 p-4 rounded-2xl bg-slate-100/80 dark:bg-white/[0.03] border border-slate-200/80 dark:border-white/[0.08]">
            <div className="flex items-center gap-2">
              <span className="text-xs font-bold text-slate-900 dark:text-white">
                {casosIndividuales.length} Casos Individuales Configurados
              </span>
              <span className="text-[11px] text-slate-500 dark:text-zinc-400">
                · Cada alumno tiene un folio y caso independiente
              </span>
            </div>

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => inicializarDistribucion(listaAlumnosDisponibles)}
                className="px-3 py-1.5 rounded-xl border border-slate-200 dark:border-white/10 hover:bg-slate-100 dark:hover:bg-white/5 text-xs font-bold text-slate-700 dark:text-zinc-300 flex items-center gap-1.5 transition-all"
              >
                <Shuffle className="h-3.5 w-3.5 text-cyan-500" />
                <span>Re-asignar Casos</span>
              </button>

              <button
                type="button"
                onClick={agregarCasoIndividual}
                className="px-3.5 py-1.5 rounded-xl border border-cyan-500/30 bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 hover:bg-cyan-500/20 text-xs font-bold flex items-center gap-1.5 transition-all"
              >
                <Plus className="h-3.5 w-3.5" />
                <span>+ Agregar Otro Caso</span>
              </button>
            </div>
          </div>

          {/* Grilla de Casos Individuales */}
          <div className="grid grid-cols-1 gap-4">
            {casosIndividuales.map((caso) => {
              const plantillaActiva =
                CATALOGO_CASOS_PORTUARIOS.find((p) => p.id === caso.plantillaId) ||
                CATALOGO_CASOS_PORTUARIOS[0]

              return (
                <div
                  key={caso.idCaso}
                  className={`p-6 rounded-[22px] border backdrop-blur-xl transition-all ${
                    caso.inyectarReto
                      ? 'border-amber-500/40 bg-amber-500/[0.02] dark:bg-amber-500/[0.04]'
                      : 'border-slate-200/80 bg-white/80 dark:border-white/10 dark:bg-[#0c0c0e]'
                  }`}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4 mb-4 border-b border-slate-100 dark:border-white/5">
                    <div className="flex flex-wrap items-center gap-2.5">
                      <span className="px-3 py-1 rounded-lg bg-cyan-600 text-white font-mono font-bold text-xs">
                        Caso #{caso.numero}
                      </span>
                      <span className="text-xs font-bold text-slate-900 dark:text-white">
                        {caso.alumno.nombre ? `Alumno: ${caso.alumno.nombre}` : 'Sin alumno asignado'}
                      </span>
                    </div>

                    <div className="flex items-center gap-3 self-end sm:self-auto">
                      <label className="flex items-center gap-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={caso.inyectarReto}
                          onChange={(e) =>
                            actualizarCasoIndividual(caso.idCaso, { inyectarReto: e.target.checked })
                          }
                          className="h-4 w-4 rounded text-amber-500 focus:ring-amber-500 cursor-pointer"
                        />
                        <span
                          className={`text-xs font-bold ${
                            caso.inyectarReto
                              ? 'text-amber-600 dark:text-amber-400'
                              : 'text-slate-400 dark:text-zinc-500'
                          }`}
                        >
                          {caso.inyectarReto ? '⚠️ Modo Reto (Discrepancia Oculta)' : 'Flujo Conforme'}
                        </span>
                      </label>

                      <button
                        type="button"
                        onClick={() => eliminarCasoIndividual(caso.idCaso)}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-500/10 transition-colors"
                        title="Eliminar este caso"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </div>

                  {/* Detalle del Reto si está activo */}
                  {caso.inyectarReto && (
                    <div className="mb-4 p-3 rounded-xl bg-amber-500/10 border border-amber-500/20 flex items-start gap-2.5">
                      <AlertCircle className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" />
                      <div className="space-y-0.5">
                        <p className="text-xs font-bold text-amber-800 dark:text-amber-300">
                          Reto Oculto de Auditoría:
                        </p>
                        <p className="text-[11px] text-amber-700 dark:text-amber-300/80 leading-snug">
                          {plantillaActiva.retoDiscrepancia.descripcion}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Campos de Configuración del Caso */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Alumno Asignado */}
                    <div>
                      <SelectorAlumno
                        rol="INDIVIDUAL"
                        labelRol="Alumno Responsable de la Operación"
                        alumnoSeleccionado={caso.alumno}
                        onChange={(alm) => actualizarCasoIndividual(caso.idCaso, { alumno: alm })}
                        alumnosDisponibles={listaAlumnosDisponibles}
                      />
                    </div>

                    {/* Plantilla del Caso */}
                    <div className="space-y-1.5">
                      <label className="block text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-zinc-400">
                        Caso Operativo Portuario
                      </label>
                      <select
                        value={caso.plantillaId}
                        onChange={(e) =>
                          actualizarCasoIndividual(caso.idCaso, { plantillaId: e.target.value })
                        }
                        className="w-full px-3.5 py-2.5 rounded-xl text-xs bg-slate-100/80 dark:bg-[#121217] border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white font-bold focus:outline-none focus:border-cyan-500 [&>option]:bg-white dark:[&>option]:bg-[#121217]"
                      >
                        {CATALOGO_CASOS_PORTUARIOS.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.titulo} ({p.tipoOperacion} · {p.lineaNaviera})
                          </option>
                        ))}
                      </select>
                      <div className="flex items-center gap-2 pt-1 text-[11px] text-slate-500 dark:text-zinc-400 font-mono">
                        <span>{plantillaActiva.buqueNombre}</span>
                        <span>·</span>
                        <span>{plantillaActiva.tipoContenedor}</span>
                        <span>·</span>
                        <span>{plantillaActiva.incoterm}</span>
                        <span>·</span>
                        <span>{plantillaActiva.terminal}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* VISTA 2: MODO EQUIPOS COLABORATIVOS */}
      {/* ========================================================================= */}
      {modo === 'equipos' && (
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3 p-4 rounded-2xl bg-indigo-500/5 border border-indigo-500/20">
            <div className="flex items-center gap-2">
              <span className="text-xs font-bold text-indigo-700 dark:text-indigo-300">
                {celulas.length} Equipos Colaborativos
              </span>
              <span className="text-[11px] text-slate-500 dark:text-zinc-400">
                · Los alumnos se distribuyen los 3 roles de comercio exterior
              </span>
            </div>

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => inicializarDistribucion(listaAlumnosDisponibles)}
                className="px-3.5 py-1.5 rounded-xl border border-indigo-500/30 bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-500/20 text-xs font-bold flex items-center gap-1.5 transition-all"
              >
                <Shuffle className="h-3.5 w-3.5" />
                <span>Re-distribuir Equipos</span>
              </button>

              <button
                type="button"
                onClick={agregarCelulaManual}
                className="px-3.5 py-1.5 rounded-xl border border-slate-200 dark:border-white/10 hover:bg-slate-100 dark:hover:bg-white/5 text-xs font-bold text-slate-700 dark:text-zinc-300 flex items-center gap-1.5 transition-all"
              >
                <Plus className="h-3.5 w-3.5" />
                <span>Agregar Otro Equipo</span>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {celulas.map((celula) => {
              const plantillaActiva =
                CATALOGO_CASOS_PORTUARIOS.find((p) => p.id === celula.plantillaId) ||
                CATALOGO_CASOS_PORTUARIOS[0]

              return (
                <div
                  key={celula.idCelula}
                  className={`p-6 rounded-[22px] border backdrop-blur-xl transition-all ${
                    celula.inyectarReto
                      ? 'border-amber-500/40 bg-amber-500/[0.02] dark:bg-amber-500/[0.04]'
                      : 'border-slate-200/80 bg-white/80 dark:border-white/10 dark:bg-[#0c0c0e]'
                  }`}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4 mb-4 border-b border-slate-100 dark:border-white/5">
                    <div className="flex flex-wrap items-center gap-2.5">
                      <span className="px-3 py-1 rounded-lg bg-indigo-600 text-white font-mono font-bold text-xs">
                        Equipo #{celula.numero}
                      </span>

                      <div className="relative">
                        <select
                          value={celula.plantillaId}
                          onChange={(e) =>
                            actualizarCelula(celula.idCelula, { plantillaId: e.target.value })
                          }
                          className="px-3 py-1.5 rounded-xl text-xs font-bold bg-slate-100/80 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white focus:outline-none focus:border-indigo-500 [&>option]:bg-white dark:[&>option]:bg-[#121217]"
                        >
                          {CATALOGO_CASOS_PORTUARIOS.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.titulo} ({p.tipoOperacion} · {p.lineaNaviera})
                            </option>
                          ))}
                        </select>
                      </div>

                      <span className="text-[11px] text-slate-500 dark:text-zinc-400 font-mono">
                        {plantillaActiva.tipoContenedor} · {plantillaActiva.incoterm}
                      </span>
                    </div>

                    <div className="flex items-center gap-3 self-end sm:self-auto">
                      <label className="flex items-center gap-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={celula.inyectarReto}
                          onChange={(e) =>
                            actualizarCelula(celula.idCelula, { inyectarReto: e.target.checked })
                          }
                          className="h-4 w-4 rounded text-amber-500 focus:ring-amber-500 cursor-pointer"
                        />
                        <span
                          className={`text-xs font-bold ${
                            celula.inyectarReto
                              ? 'text-amber-600 dark:text-amber-400'
                              : 'text-slate-400 dark:text-zinc-500'
                          }`}
                        >
                          {celula.inyectarReto ? '⚠️ Modo Reto (Discrepancia Oculta)' : 'Flujo Conforme'}
                        </span>
                      </label>

                      <button
                        type="button"
                        onClick={() => eliminarCelula(celula.idCelula)}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-500/10 transition-colors"
                        title="Eliminar este equipo"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </div>

                  {celula.inyectarReto && (
                    <div className="mb-4 p-3 rounded-xl bg-amber-500/10 border border-amber-500/20 flex items-start gap-2.5">
                      <AlertCircle className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" />
                      <p className="text-[11px] text-amber-800 dark:text-amber-300 leading-snug">
                        <strong>Reto de Auditoría:</strong> {plantillaActiva.retoDiscrepancia.descripcion}
                      </p>
                    </div>
                  )}

                  {/* Los 3 Roles de la Cadena de Suministro */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <SelectorAlumno
                      rol="EMISOR"
                      labelRol="1. Exportador (Shipper)"
                      alumnoSeleccionado={celula.emisor}
                      onChange={(alumno) => actualizarCelula(celula.idCelula, { emisor: alumno })}
                      alumnosDisponibles={listaAlumnosDisponibles}
                    />

                    <SelectorAlumno
                      rol="AGENTE"
                      labelRol="2. Agente Aduanal (Patente)"
                      alumnoSeleccionado={celula.agenteAduanal}
                      onChange={(alumno) =>
                        actualizarCelula(celula.idCelula, { agenteAduanal: alumno })
                      }
                      alumnosDisponibles={listaAlumnosDisponibles}
                    />

                    <SelectorAlumno
                      rol="RECEPTOR"
                      labelRol="3. Terminal / Receptor SSA"
                      alumnoSeleccionado={celula.receptor}
                      onChange={(alumno) => actualizarCelula(celula.idCelula, { receptor: alumno })}
                      alumnosDisponibles={listaAlumnosDisponibles}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* BARRA FLOTANTE BENTO DE PUBLICACIÓN */}
      {/* ========================================================================= */}
      <div className="sticky bottom-4 z-20 p-4 sm:p-5 rounded-[24px] bg-white/95 dark:bg-[#0c0c0e]/95 border border-slate-200/80 dark:border-white/[0.08] shadow-2xl backdrop-blur-xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <p className="text-xs sm:text-sm font-black text-slate-900 dark:text-white">
            Publicar {cantidadCasos} Prácticas para el Salón {grupoActivo?.nombre || '4-CAS-1'}
          </p>
          <p className="text-[11px] text-slate-500 dark:text-zinc-400">
            {modo === 'individual'
              ? 'Cada alumno recibirá su caso independiente en tiempo real.'
              : 'Los alumnos colaborarán en equipo asignados a sus roles de comercio exterior.'}
          </p>
        </div>

        <button
          type="button"
          disabled={publicando}
          onClick={handlePublicar}
          className="w-full sm:w-auto px-8 py-3 rounded-xl bg-gradient-to-r from-cyan-600 via-blue-600 to-indigo-600 hover:from-cyan-500 hover:to-indigo-500 text-white font-black text-xs uppercase tracking-wider shadow-lg shadow-cyan-500/20 transition-all flex items-center justify-center gap-2 hover:scale-[1.02] active:scale-95 disabled:opacity-50"
        >
          {publicando ? (
            <>
              <RefreshCw className="h-4 w-4 animate-spin" />
              <span>Sincronizando con Servidor...</span>
            </>
          ) : (
            <>
              <CheckCircle2 className="h-4 w-4" />
              <span>⚡ Publicar Prácticas del Salón</span>
            </>
          )}
        </button>
      </div>
    </div>
  )
}
